// API Configuration
export const API_CONFIG = {
  // Base URL for API calls
  BASE_URL: process.env.REACT_APP_API_URL, // Update this to your actual API URL
  
  // API Endpoints - Updated to match backend Swagger UI
  ENDPOINTS: {
    // Authentication - Match backend exactly
    LOGIN: '/Auth/login',
    REGISTER: '/Auth/register',
    LOGOUT: '/Secure/logout',
    REFRESH_TOKEN: '/Auth/refresh',
    FORGOT_PASSWORD: '/Auth/forgot-password',
    RESET_PASSWORD: '/Auth/reset-password',
    CHANGE_PASSWORD: '/Auth/change-password',
    IS_AUTHENTICATED: '/Auth/isAuthenticated',
    VERIFY_EMAIL: '/Auth/verify-email',
    RESEND_EMAIL_VERIFICATION: '/Auth/resend-email-verification',
    CONFIRM_EMAIL_CHANGE: '/Auth/confirm-email-change',
    SET_PASSWORD: '/Auth/set-password',
    
    // Social Authentication
    SOCIAL_LOGIN: '/Auth/social-login',
    
    // Mobile Authentication
    SEND_OTP: '/Auth/send-otp',
    VERIFY_OTP: '/Auth/verify-otp',
    
    // User Management
    GET_USER_PROFILE: '/user/profile',
    UPDATE_USER_PROFILE: '/user/profile',
    DELETE_ACCOUNT: '/Auth/deleteUser',
    
    // Device Management
    GET_DEVICES: '/devices',
    GET_USER_DEVICES: '/Device/userDevices',
    GET_DEVICE_DETAILS: '/Device/device/:id',
    GET_DEVICE_BY_SERIAL: '/Device/devices/serial/:serialNumber',
    ADD_DEVICE: '/Device/addDevices',
    GET_DEVICES_FOR_DASHBOARD: '/Device/dashboard/user',
    GET_DEMO_DEVICE: '/Device/getDemoDevice',
    GET_PARAMETERS_FOR_DASHBOARD: '/Device/dashboard/parameters',
    GET_DEVICE_TYPES: '/Device/deviceTypes',
    UPDATE_DEVICE: '/Device/updateDevice/:id',
    UPDATE_DEVICE_STATUS_BY_SERIAL_NUMBER: '/Device/updateDeviceStatus',
    DELETE_DEVICE: '/Device/deleteDevice/:id',
    DELETE_DEMO_DEVICE_ALERTS_AND_SHARE_LINKS: '/Device/deleteDemoDeviceAlertsAndShareLinks',
    GET_DEVICE_SENSOR_DATA:'/Device/devices/getsensor-data',
    GET_DEVICE_HEATMAP_DATA:'/Data/getHeatMapData/',
    GET_DEVICE_HEATMAP_DATA_MINMAX:'/Data/getHeatMapDataMinMax/',
    
    // Pollutant Parameters
    GET_POLLUTANT_PARAMETERS: '/Device/pollutant-parameters',
    GET_POLLUTANT_PARAMETER_BY_ID: '/Device/pollutant-parameters/:id',
    
    // Alert Recipients
    GET_ALERT_RECIPIENTS: '/alert/:alertId/recipients',

    // AQI Info Data
    GET_AQI_INFO_DATA: '/Device/getParameterRanges',
    
    // Statistical Report
    GET_STATISTICAL_REPORT_DATA:'/Data/reports/getStatisticalReports',

    // Device offsets data
    GET_DEVICE_OFFSETS: '/Device/getDeviceOffsets/:id',
    UPDATE_DEVICE_OFFSETS: '/Device/updateDeviceOffsets/:id',

    // Export
    EXPORT_DEVICE_DATA: '/Device/deviceData/ExportToExcel',
    EXPORT_DASHBOARD_DATA: '/Device/deviceDashboardData/ExportToExcel',
    EXPORT_STATISTICAL_REPORTS_DATA: '/Data/reports/statisticalReportExportToExcel',

    // Search
    SEARCH: '/search',

    // Wifi test
    WIFI_TESTING: '/Data/wifiConnectionTest',

    // Wifi connection log
    LOG_WIFI_CONNECTION: '/Device/logWifiConnection',

    // Ticket Management
    GET_ALL_TICKETS: '/Ticket',
    GET_USER_TICKETS: '/Ticket/userTickets',
    GET_TICKET_BY_ID: '/Ticket/:ticketId',
    CREATE_TICKET: '/Ticket',
    UPDATE_TICKET: '/Ticket/:ticketId',
    DELETE_TICKET: '/Ticket/:ticketId',

    // App Version
    GET_APP_VERSION: '/AppVersion/:appName/:platform',

    // Release Notes
    GET_RELEASE_NOTES: '/ReleaseNotes/latest',

    // User Management
    GET_ALL_USERS: '/UserManagement',
    GET_USER_BY_ID: '/UserManagement/:userId',
    CREATE_USER: '/UserManagement',
    UPDATE_USER: '/UserManagement/:userId',
    DELETE_USER: '/UserManagement/:userId',
    GET_SITES: '/UserManagement/sites',
    CREATE_SITE: '/UserManagement/sites',
  },
  
  // Request Configuration
  REQUEST_CONFIG: {
    TIMEOUT: 30000, // 30 seconds
    RETRY_ATTEMPTS: 3,
    RETRY_DELAY: 1000, // 1 second
  },
  
  // Response Status Codes
  STATUS_CODES: {
    SUCCESS: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
  }
};

// Environment-specific configurations
export const getApiConfig = () => {
  const env = process.env.REACT_APP_ENV || 'development';
  
  // Check if we're in development mode (npm start)
  const isLocalDevelopment = process.env.NODE_ENV === 'development' && !process.env.REACT_APP_API_URL;
  
  switch (env) {
    case 'production':
      return {
        ...API_CONFIG,
        BASE_URL: process.env.REACT_APP_API_URL || 'https://api.smarteco.com/api',
      };
    case 'staging':
      return {
        ...API_CONFIG,
        BASE_URL: process.env.REACT_APP_API_URL || 'https://staging-api.smarteco.com/api',
      };
    case 'development':
      // If local development (npm start), use localhost
      if (isLocalDevelopment) {
        return {
          ...API_CONFIG,
          BASE_URL: 'http://localhost:5187/api',
        };
      }
      // If build:dev, use the environment variable (smarteco domain)
      return {
        ...API_CONFIG,
        BASE_URL: process.env.REACT_APP_API_URL || 'https://app.smarteco.ai/smartecodevapi/api',
      };
    default: // fallback
      // If local development (npm start), use localhost
      if (isLocalDevelopment) {
        return {
          ...API_CONFIG,
          BASE_URL: 'http://localhost:5187/api',
        };
      }
      // Otherwise use environment variable or smarteco domain
      return {
        ...API_CONFIG,
        BASE_URL: process.env.REACT_APP_API_URL || 'https://app.smarteco.ai/smartecodevapi/api',
      };
  }
}; 